import { get } from 'lodash'
import { createSelector } from 'reselect'

import { RootState } from '@/store'

import { initialState } from './reducer'

const getState = (state: RootState) => get(state, 'organizationGroupsPage', initialState)
const getGroupsById = (state: RootState) => getState(state).byId

export const getGroups = createSelector(getGroupsById, byId => {
  return Object.values(byId)
})
